import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Pending_1 = new (DeferredFragmentIdentifier())(emptyList(), '__pending');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeferredFragmentIdentifierClass;
function DeferredFragmentIdentifier() {
  if (DeferredFragmentIdentifierClass === VOID) {
    class $ {
      constructor(path, label) {
        Companion_getInstance();
        this.path_1 = path;
        this.label_1 = label;
      }
      toString() {
        return 'DeferredFragmentIdentifier(path=' + toString(this.path_1) + ', label=' + this.label_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.path_1);
        result = imul(result, 31) + (this.label_1 == null ? 0 : getStringHashCode(this.label_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeferredFragmentIdentifier()))
          return false;
        if (!equals(this.path_1, other.path_1))
          return false;
        if (!(this.label_1 == other.label_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeferredFragmentIdentifier');
    DeferredFragmentIdentifierClass = $;
  }
  return DeferredFragmentIdentifierClass;
}
//region block: exports
export {
  DeferredFragmentIdentifier as DeferredFragmentIdentifieryfmj5mbsp1mh,
  Companion_getInstance as Companion_getInstance1lkfowpfobqwc,
};
//endregion

//# sourceMappingURL=DeferredFragmentIdentifier.mjs.map
